

























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { NotificationModule } from '@/app/store/modules/notifications'
import { MasterModule } from '@/app/store/modules/master'
import { Vuelidate } from 'vuelidate'
import { Validate } from 'vuelidate-property-decorators'
import {
  required,
  minLength,
  maxLength,
  not,
  sameAs,
} from 'vuelidate/lib/validators'
import { AdminCMSRoleModule } from '@/app/store/modules/adminCMSRole'
import vueCustomScrollbar from 'vue-custom-scrollbar'

import ModalImage from '@/app/ui/components/ImageGallery/index.vue'
import ImageSelect from '@/app/ui/components/SelectImage/index.vue'

@Component({
  components: {
    'modal-image': ModalImage,
    'image-select': ImageSelect,
    vueCustomScrollbar,
  },
})
export default class extends Vue {
  @Prop({}) public idModal
  @Prop({}) public id
  @Prop({}) public roleName
  @Prop({}) public menu

  @Watch('id')
  public onPropertyChanged(value: boolean, oldValue: boolean) {
    this.options = this.menu.map((item, index) => {
      return {
        name: item.name,
        permission_id: item.permission === 'Show' ? 1 : 3,
      }
    })
  }

  public get validRoleName(): boolean {
    return this.roleName.length >= 4 ? true : false
  }

  public menuOptions = [
    { text: 'Show', value: 1 },
    { text: 'Hide', value: 3 },
  ]
  public options = [
    {
      name: 'Dashboard',
      permission_id: 3,
    },
    {
      name: 'User',
      permission_id: 3,
    },
    {
      name: 'Notification',
      permission_id: 3,
    },
    {
      name: 'Material',
      permission_id: 3,
    },
    {
      name: 'Content',
      permission_id: 3,
    },
    {
      name: 'Report',
      permission_id: 3,
    },
    {
      name: 'Master',
      permission_id: 3,
    },
    {
      name: 'CMS Setting',
      permission_id: 3,
    },
    {
      name: 'Gallery Image',
      permission_id: 3,
    },
  ]
  public $v: Vuelidate
  @Validate({
    required,
    minLength: minLength(4),
  })
  public nameRole: string = ''
  public changeRoleName(e) {
    this.nameRole = e
  }

  public resetAdd() {
    this.$v.nameRole.$reset()
    this.nameRole = ''
    this.needSalesCode = false
  }

  public onClearSelected() {
    this.$emit('onClearSelected')
  }

  public stateDashboard = 3
  public stateNotification = 3
  public stateContent = 3
  public stateMaster = 3
  public stateGallery = 3
  public stateUser = 3
  public stateMaterial = 3
  public stateReport = 3
  public stateAdminCMS = 3
  public needSalesCode = false

  public updateData(item, index, button) {
    if (this.validRoleName === false) {
      return
    } else {
      const dataToEdit = {
        id: this.id,
        roleName: this.nameRole === '' ? this.roleName : this.nameRole,
        menu: this.options,
      }
      AdminCMSRoleModule.updateAdminCMSRole(dataToEdit)
      this.$root.$emit('bv::hide::modal', 'modal-edit-role', button)
    }
  }
}
